export const THEME_COOKIE_NAME = "themeMode";

export const getCookieValue = (cookieString: string, name: string): string => {
    const cookies = cookieString.split(";");

    for (const cookie of cookies) {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith(`${name}=`)) {
            return trimmedCookie.substring(name.length + 1);
        }
    }

    return "";
};

export const resolveInitialTheme = (
    cookieString: string,
    prefersDark: boolean,
): boolean => {
    const themeCookie = getCookieValue(cookieString, THEME_COOKIE_NAME);

    if (themeCookie === "dark") {
        return false;
    }

    if (themeCookie === "light") {
        return true;
    }

    return !prefersDark;
};
